// Simple analytics tracking (stub - replace with actual analytics service)

interface AnalyticsEvent {
  action: string;
  category: string;
  label?: string;
  value?: number;
}

const trackEvent = (event: AnalyticsEvent): void => {
  // Stub: log to console (replace with actual analytics service)
  console.log('Analytics event:', event);

  // Example: Google Analytics 4
  // if (typeof gtag !== 'undefined') {
  //   gtag('event', event.action, {
  //     event_category: event.category,
  //     event_label: event.label,
  //     value: event.value,
  //   });
  // }
};

export function initAnalytics(): void {
  // Track CTA clicks
  const ctaButtons = document.querySelectorAll('a[href^="#"], .btn[href^="#"]');
  ctaButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('href');
      if (target && target.startsWith('#')) {
        trackEvent({
          action: 'click',
          category: 'CTA',
          label: target,
        });
      }
    });
  });

  // Track form submissions
  const forms = document.querySelectorAll('form');
  forms.forEach((form) => {
    form.addEventListener('submit', () => {
      trackEvent({
        action: 'submit',
        category: 'Form',
        label: form.id || 'unknown',
      });
    });
  });

  // Track lead magnet downloads
  const leadMagnetForm = document.getElementById('lead-magnet-form');
  if (leadMagnetForm) {
    leadMagnetForm.addEventListener('submit', () => {
      trackEvent({
        action: 'download',
        category: 'Lead Magnet',
        label: 'DipIFR Checklist',
      });
    });
  }

  // Track external links
  const externalLinks = document.querySelectorAll('a[target="_blank"]');
  externalLinks.forEach((link) => {
    link.addEventListener('click', () => {
      trackEvent({
        action: 'click',
        category: 'External Link',
        label: (link as HTMLAnchorElement).href,
      });
    });
  });

  // Track scroll depth (optional)
  let maxScroll = 0;
  window.addEventListener('scroll', () => {
    const scrollPercent = Math.round(
      ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100
    );

    if (scrollPercent > maxScroll && scrollPercent >= 25) {
      maxScroll = scrollPercent;
      if (
        scrollPercent === 25 ||
        scrollPercent === 50 ||
        scrollPercent === 75 ||
        scrollPercent === 100
      ) {
        trackEvent({
          action: 'scroll',
          category: 'Engagement',
          label: `${scrollPercent}%`,
          value: scrollPercent,
        });
      }
    }
  });
}
